<template>
  <div class="user-privacy">
      <p class="bold center">可瀚学堂用户服务协议</p>
      <p>导言<br>欢迎使用可瀚学堂应用！</p>
      <p>为使用可瀚学堂应用，您应当阅读并遵守<span class="blue">《可瀚学堂用户服务协议》</span>（以下简称“本协议”），请您务必审慎阅读并选择接受或不接受本协议，如您不同意本协议任何内容，请勿注册或使用可瀚学堂应用提供的任何服务。您注册或使用可瀚学堂软件，均视为您已阅读并同意签署本协议，本协议即在您与深圳市格熙信息科技有限公司之间产生法律效力，成为对双方均具有约束力的法律文件。</p>
      <p>如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人（以下简称“监护人”）的陪同下阅读和判断是否同意本协议，并特别注意未成年人使用条款。</p>
      <p>如果您是中国大陆地区以外的用户，您订立或履行本协议还需要同时遵守您所属和/或所处国家或地区的法律。 </p>
      <p class="bold">1.协议的适用范围</p>
      <p>1.1协议适用主体范围</p>
      <p>本协议是您与深圳市格熙信息科技有限公司（以下又称“我们”或“可瀚学堂”）之间关于您下载、安装、使用本软件，以及使用可瀚学堂相关服务（以下合称“可瀚学堂服务”）所订立的协议。如果您是未成年人，您应在法定监护人陪同下阅读、理解本协议，并特别注意未成年人使用条款。</p>
      <p>可瀚学堂有权根据需要不时地制定、修改本协议或各类规则，如本协议有任何变更，可瀚学堂将通过我们的网站、可瀚学堂应用或其他方式通知您。如您不同意相关变更，可以选择停止使用“服务”。经修订的协议一经在可瀚学堂公布后，立即自动生效。登录或继续使用“服务”将表示用户接受经修订的协议。您可以通过“我的-设置-关于我们”路径查阅本协议及《隐私政策》的最新版本。</p>
      <p class="bold">2.可瀚学堂服务</p>
      <p>2.1可瀚学堂服务的形式</p>
      <p>您使用可瀚学堂服务需要下载可瀚学堂客户端软件，对于此软件，可瀚学堂给予一项个人的、不可转让及非排他性的使用许可，您可以为非商业目的在一台终端设备上安装、使用、显示、运行本软件。本条及本协议其他条款未明示授权的其他一切权利仍由可瀚学堂保留；可瀚学堂服务中，可瀚学堂客户端软件提供包括但不限于iOS、Android 多个应用版本，您可选择与所安装设备相匹配的软件版本。</p>
      <p class="bold">3.软件的获取</p>
      <p>您可以直接从可瀚学堂的网站（www.kehigh.com）上获取本软件，也可以从得到可瀚学堂授权的第三方获取。如果您从未经可瀚学堂授权的第三方获取本软件或与本软件名称相同的安装程序，可瀚学堂无法保证该软件能够正常使用，该软件还有可能给您造成不必要的损失。</p>
      <p class="bold">4.软件的安装与卸载</p>
      <p>4.1如果您是未成年人，我们建议您在使用可瀚学堂服务时，请您的家长安装使用可瀚学堂提供的可瀚学堂应用，以便您的家长能够监督、指导您的学习过程。为了节约您的流量，可瀚学堂建议您在WIFI环境下下载相关应用。</p>
    <p>4.2如果您不再需要使用本软件或者需要安装新版软件，可以自行卸载。如果您愿意帮助可瀚学堂改进产品服务，请告知卸载的原因。</p>
        <p class="bold">5.软件的更新</p>
      <p>为了改善用户体验、完善服务内容，可瀚学堂将不断努力开发新的服务，并为您的孩子不时提供软件更新（包括但不限于软件替换、 修改、功能强化、版本升级等形式）。此等更新可能对软件的部分功能效果进行改变或限制，此等更新发生前可能不会事先向您特别通知。</p>
      <p class="bold">6.用户个人信息保护</p>
      <p>
        <p>6.1关于注册信息</p>
        <p>您须按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，方可获得可瀚学堂账户。</p>
        <p><span class="bold">6.1.1您必须至少年满18周岁，有能力订立具有法律约束力的合同，如果您是未成年人，请在您的监护人的监督、指导下阅读、理解并接受本《服务协议》，以访问和使用可瀚学堂应用。</span>
        您访问或使用可瀚学堂应用，即表示您陈述和保证您已年满18周岁且具有订立合同的法律行为能力和授权，或者您已在您监护人的监督、指导下阅读、理解并接受本《服务协议》且您的监护人已阅读、理解并接受本《服务协议》。</p>
        <p><span class="bold">6.1.2您需负责：（i）保管用以进入您的账户和我们的服务的任何密码；（ii）承担通过您的账户对我们的服务所做出的一切使用行为。如您发现或怀疑您的账户或密码已经泄露，必须尽快通知我们。除非我们已接获并确认收到您向我们发出关于您的账户/密码被泄露的通知，我们会将所有在我们的服务内对您账户的使用视为由您做出。因您保管不善可能导致遭受盗号或密码失窃，责任由您自行承担。</span></p>
        <p>6.2用户隐私制度</p>
        <p>6.2.1尊重用户个人隐私是可瀚学堂的一项基本政策。可瀚学堂会尽最大努力使用相关安全技术和程序，建立完善的管理制度以保护您的个人信息免遭受泄露；可瀚学堂不会在未经您明示授权时透露您的注册资料，除非：</p>
        <p>（1）相关法律法规或国家机关要求；</p>
        <p>（2）可瀚学堂发生相关合并、分立、收购 或资产转移；</p>
        <p>（3）为提供您需要的服务所必须的；</p>
        <p>（4）可瀚学堂可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与可瀚学堂同等的保护用户隐私的责任，则可瀚学堂有权将用户的注册资料等提供给该第三方。</p>
        <p>对于您所提交的注册信息中涉及个人信息的内容，我们将严格按照《隐私政策》的规定进行收集、处理和使用。</p>
        <p>6.2.2在不恶意透露用户的个人敏感信息且对用户信息进行去标识化处理的前提下，可瀚学堂有权收集用户数据并对其进行合法的商业化使用。</p>
        <p>6.3用户账号安全性</p>
        <p>6.3.1您在使用可瀚学堂服务过程中应避免透露各类财产账户、银行卡、信用卡、第三方支付账户及对应密码等重要资料，否则由此造成的损失由您自行承担。除使用可瀚学堂服务所必要的信息，我们不建议您将个人敏感信息通过可瀚学堂应用上传，以避免不必要的损失。</p>
        <p>6.3.2您可随时更正、修改您上传到可瀚学堂应用中的信息，也可以随时注销账户并重开一个新账户。如您想注销账户，请拨打客服电话:17796327580，告知注销原因后，即可注销可瀚学堂账号。用户若发现任何非法使用用户账号或安全漏洞的情况，请立即通告可瀚学堂。</p>
      </p>
      <p class="bo">7.权利义务条款</p>
      <p>7.1您理解并同意：为了向您提供服务本软件会利用您或您孩子的移动通讯终端的处理器和带宽等资源。本软件使用过程中可能产生数据流量的相关资费，您需自行向运营商了解相关资费信息，并自行承担相关费用。</p>
       <p>7.2 可瀚学堂应用中可能存在由第三方提供的服务或由可瀚学堂提供的特定服务，该服务可能会另有单独的协议以便使用或开通该功能或服务。</p>
       <p>7.3您使用可瀚学堂服务，需要遵守相关法律法规以及本《服务协议》的规定。如用户存在违反相关法律法规规定的行为或严重违反本《服务协议》的行为，可瀚学堂有权中断对其提供服务。7.4您在通过本软件使用第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。</p>
      <p class="bold">8.用户行为规范</p>
      <p>8.1信息内容规范</p>
      <p>8.1.1信息使用：</p>
      <p>(i)可瀚学堂不会向任何人出售或出借用户的个人信息，除非事先得到用户的许可；</p>
      <p>(ii)可瀚学堂不允许任何第三方以任何手段收集、编辑、出售或者无偿传播可瀚学堂APP用户的个人信息。任何用户如从事上述活动，一经发现，我们有权终止与该用户的服务协议、查封其账号；</p>
      <p>8.1.2信息披露：用户的个人信息将在下述情况下部分或全部披露：</p>
      <p>(iii)经用户同意，向第三方披露；</p>
      <p>(iv)根据法律的有关规定，或者教育主管部门、行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
      <p>(v)如果用户出现违反中国有关法律或者网站政策的情况，需要向第三方披露；</p>
      <p>(vi)未提供用户所要求的产品和服务，而必须和第三方分享用户的个人信息。</p>
      <p>(vii)其他。我们根据法律或者网站政策认为合适的披露。</p>
      <p> 8.1.3您理解并同意，可瀚学堂一直致力于提供文明健康、规范有序的网络环境，您不得利用可瀚学堂软件及服务制作、复制、发布、传播任何有悖于社会主义价值观、侵犯任何第三方合法权益或干扰可瀚学堂正常运营的内容包括但不限于：</p>
      <p> 8.1.3.1发布、传送、传播、储存违反国家法律法规禁止的内容：</p>
      <p>（1）违反宪法确定的基本原则的；</p>
      <p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
      <p>（3）损害国家荣誉和利益的；</p>
      <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
      <p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
      <p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
      <p>（7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
      <p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
      <p>（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；</p>
      <p>（10）以非法民间组织名义活动的；</p>
      <p>（11）不符合《即时通信工具公众信息服务发展管理暂行规定》及遵守法律法规、社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求的；</p>
      <p>（12）含有法律、行政法规禁止的其他内容的。</p>
      <p>8.1.3.2发布、传送、传播、储存侵害他人名誉 权、肖像权、知识产权、商业秘密等合法权利的内容；</p>
      <p>（1）涉及他人隐私、个人信息或资料的；</p>
      <p>（2）发表、传送、传播骚扰、广告信息及垃圾信息或含有任何性或性暗示的；</p>
      <p>（3）其他违反法律法规、政策及公序良俗、社会公德或干扰可瀚学堂公众平台正常运营和侵犯其他用户或第三方合法权益内容的信息。</p>
      <p>8.1.4您承诺并保证：</p>
      <p>（i）您对您的内容享有完整权利，并有权授予我们本条款项下的各项权利；</p>
      <p>（ii）	您的内容并未侵犯任何第三人的权利，我们根据您的授权使用您的内容亦不会对第三方构成侵权或触犯任何法律法规。</p>
      <p>8.1.5如果我们收到权利人通知，主张您发送或传播的内容侵犯其相关权利的，您同意我们有权进行独立判断并采取删除、屏蔽或断开链接等措施。</p>
      <p>8.1.6我们收集、保存、传输、使用您的内容将不违反相关法律规定，并适用我们的《隐私政策》，受其约束。</p>
      <p>8.2软件使用规范</p>
      <p>除非法律允许或可瀚学堂书面许可，您使用本软件过程中不得从事下列行为：</p>
      <p>（1）删除本软件及其副本上关于著作权的信息；</p>
      <p>（2）对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码；</p>
      <p>（3）对可瀚学堂拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</p>
      <p>（4）对本软件或者本软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户与服务器端的交互数据，以及本软件运行所必需的系统数据，进行复制、修改、增加、删 除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非可瀚学堂授权的第三方工具/服务接入本软件和相关系统；</p>
      <p>（5）通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</p>
      <p>（6）通过非可瀚学堂开发、授权的第三方 软件、插件、外挂、系统，登录或使用可瀚学堂软件及服务，或制作、发布、传播上述工具；</p>
      <p>（7）自行或者授权他人、第三方软件对本软件及其组件、模块、数据进行干扰；</p>
      <p>（8）其他未经可瀚学堂明示授权的行为。</p>
      <p>8.3可瀚学堂为了保护学生的身体健康，保证学生的视力不受损害，可瀚学堂做了以下努力：</p>
      <p>（1）可瀚学堂建议老师将单次练习的时间控制在20分钟之内，避免长时间练习损伤学生视力；</p>
      <p>（2）您使用可瀚学堂学习时，系统每隔20分钟会自动提醒学生稍作休息，保护学生身心健康。</p>
      <p class="bold">9.知识产权声明</p>
      <p>9.1 可瀚学堂向用户提供的所有产品和服务，包括但不限于商标、域名、软件程序、图片、声音、录像、图表、标志、标识、版面设计、目录与名称等，均归可瀚学堂所有，受国家相关法律保护。</p>
      <p>9.2未经可瀚学堂书面许可，任何单位及个人不得将上述产品、服务、信息、文字材料的任何部分用于商业、营利或广告目的；不得擅自进行复制、分发、修改、编辑、传播、表演、展示、程序反向工程、镜像、销售或与其它产品捆绑使用、销售。</p>
      <p>9.3用户使用可瀚学堂提供的内容时，应遵守知识产权及其他相关法律的规定。</p>
      <p>9.4未经可瀚学堂或相关权利人先书面同意，您不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。</p>
      <p>9.5您向我们提供任何有关我们服务的意见、建议或评价全部均是自愿的，我们可以自行使用该等意见、建议和评价，而不须向您支付费用或对您负任何责任。</p>
      <p class="bold">10.法律责任声明</p>
      <p>10.1可瀚学堂转载的文章、图片、音频视频文件等资料的著作权归相关权利人所有。如您对可瀚学堂上的内容有任何疑问或异议，请通过电话（17796327580）联系我们，我们将有专门人员核实、处理。</p>
      <p>10.2对于可瀚学堂创作的或获得独家使用授权的文章、图片、音视频等资料，任何第三方如需转载使用，需事先征得可瀚学堂和著作权所有人的同意。</p>
      <p>10.3您同意并理解：可瀚学堂应用中所体现的成就等信息仅为激发学生学习兴趣，增加学习趣味性所用，其并不能作为学生学习情况权威认证使用，亦不得用于任何证明学生能力的相关凭证。</p>
      <p class="bold">11.服务终止</p>
      <p>11.1我们可以暂停或终止您进入您可瀚学堂应用账户或我们的部分或所有服务：</p>
      <p>（i）如我们合理相信您已违反本协议；</p>
      <p>（ii）如您使用可瀚学堂服务对我们或我们的其他用户造成风险、可能导致我们面临第三方提出索赔的威胁，或可能影响我们的声誉；在可行情况下，我们会向您发出暂停或终止服务通知。</p>
      <p>11.2在终止本条款后，我们会根据本条款及我们的《隐私政策》保留并使用您的内容。如我们暂停或终止某服务，或您或我们终止您进入我们的服务，我们不保证我们可以将您的任何内容交还给您，请确保您定期为您的内容存档。而且我们可能会在服务终止后的任何时间永久删除您的内容，在删除内容前我们会通过短信、向您致电或其他有效的联系方式通知您。</p>
      <p>11.3您理解并同意，我们的所有服务和软件均是按原状而提供。我们将尽最大努力向您提供服务，确保服务的连贯性和安全性；但可瀚学堂没有对我们的服务、软件或任何通过可瀚学堂的服务提交、提供或显示的内容做出任何声明、保证或给予任何承诺，包括：</p>
      <p>（i）我们的服务或软件将不受干扰、是安全的、没有 错漏或没有病毒；</p>
      <p>（ii）我们的服务或软件将会与您的设备兼容；</p>
      <p>（iii）我们的服务或软件将具适销质量、适合特定用途或没有侵犯任何人的知识产权的任何声明、保证或承诺。</p>
      <p>11.4您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使服务中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟 疫流行和风暴等以及社会事件如战争、动乱、 政府行为等。出现上述情况时，我们将努力在第一时间与相关单位配合，及时进行修复，但是由此给您造成的损失我们在法律允许的范围内免责。</p>
      <p>11.5在法律允许的范围内，我们对以下情形导致的服务中断或受阻不承担责任：</p>
      <p>(i)受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</p>
      <p>(ii)用户或我们的电脑软件、系统、硬件和通信线路出现故障；</p>
      <p>(iii)用户操作不当；</p>
      <p>(iv)用户通过非可瀚学堂授权的方式使用本服务；</p>
      <p>(v)其他可瀚学堂无法控制或合理预见的情形。</p>
      <p>12.6您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来风险，我们不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。</p>
      <p class="bold">12.未成年使用条款</p>
      <p>12.1<span class="bold">若您未满18周岁，则为未成年人，应在监护人监护、指导下阅读本协议和使用本服务。</span></p>
      <p>12.2未成年人用户在使用可瀚学堂技提供的服务时，应注意以下事项，提高安全意识，加强自我保护：</p>
      <p>（1）认清网络世界与现实世界的区别，有效利用本软件辅助日常学习，避免沉迷网络；</p>
      <p>（2）填写个人资料时，加强个人保护意识，以免不良分子对个人生活造成骚扰；</p>
      <p>（3）在监护人或老师的指导下，学习正确使用网络；</p>
      <p>12.3监护人、学校均应对未成年人使用可瀚学堂服务时多做监督和引导。</p>
      <p class="bold">13.其他</p>
      <p>13.1本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</p>
      <p>13.2如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可将纠纷或争议提交本协议签订地（即中国广东省深圳市南山区）有管辖权的人民法院管辖。</p>
      <p>13.3如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
  </div>
</template>

<script>
export default {
  created(){
        document.title = '可瀚学堂用户服务协议'
    }
}
</script>
<style scoped lang='scss'>
    .user-privacy{
        margin: 0 26px 0 19px;
        padding-bottom: 50px;
        color: #7a7988;
        font-size: 15px;
        & > p {
            margin-top: 22px;
            line-height: 20px;
        }
        .bold{
            font-weight: bold;
        }
        .blue{
            color: #24b8fe;
        }
        .center{
            text-align: center;
        }
    }
</style>
